import { render, staticRenderFns } from "./k2SelectStudent.vue?vue&type=template&id=13277bf5&scoped=true"
import script from "./k2SelectStudent.vue?vue&type=script&lang=js"
export * from "./k2SelectStudent.vue?vue&type=script&lang=js"
import style0 from "./k2SelectStudent.vue?vue&type=style&index=0&id=13277bf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13277bf5",
  null
  
)

export default component.exports